/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 */

(function () {
  function initProductPromoModal() {
    var openButtons = document.querySelectorAll("[data-product-promo-open]");

    openButtons.forEach(function (openButton) {
      var modalId = openButton.getAttribute("aria-controls");
      var modal = document.getElementById(modalId);

      if (!modal) {
        return;
      }

      var closeButtons = modal.querySelectorAll("[data-product-promo-close]");
      var previousOverflow = "";

      function openModal() {
        previousOverflow = document.body.style.overflow;
        modal.hidden = false;
        openButton.setAttribute("aria-expanded", "true");
        document.body.style.overflow = "hidden";

        var closeButton = modal.querySelector(".product-promo-modal__close");
        if (closeButton) {
          closeButton.focus();
        }
      }

      function closeModal() {
        modal.hidden = true;
        openButton.setAttribute("aria-expanded", "false");
        document.body.style.overflow = previousOverflow;
        openButton.focus();
      }

      openButton.addEventListener("click", openModal);

      closeButtons.forEach(function (closeButton) {
        closeButton.addEventListener("click", closeModal);
      });

      document.addEventListener("keydown", function (event) {
        if (event.key === "Escape" && !modal.hidden) {
          closeModal();
        }
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initProductPromoModal);
  } else {
    initProductPromoModal();
  }
})();
